"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSmartContracts = exports.initSC = exports.removeWriteSmartContracts = void 0;
var store_1 = require("@celestejs/store");
var _store_1$actions = store_1.actions,
  add_contract = _store_1$actions.add_contract,
  remove_contract = _store_1$actions.remove_contract;
function removeWriteSmartContracts() {
  var contracts = store_1.store.getState().web3Reducer.contracts;
  Object.keys(contracts).forEach(function (key) {
    if (key.includes('_READ')) return;
    store_1.store.dispatch(remove_contract(key, null));
  });
}
exports.removeWriteSmartContracts = removeWriteSmartContracts;
function initSC(address, smartContract, web3, key) {
  var abi = smartContract.abi,
    scKey = smartContract.key;
  var contract = new web3.eth.Contract(abi, address);
  store_1.store.dispatch(add_contract("".concat(scKey).concat(key), contract));
}
exports.initSC = initSC;
function initSmartContracts(config, web3, chainId) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var _this = this;
    var smartContracts, isMultichain;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          smartContracts = config.smartContracts, isMultichain = config.isMultichain;
          smartContracts.forEach(function (sc) {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
              var address;
              return _regenerator["default"].wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    address = isMultichain ? sc.address[chainId] : sc.address;
                    if (address) {
                      _context.next = 3;
                      break;
                    }
                    return _context.abrupt("return");
                  case 3:
                    initSC(address, sc, web3, '');
                  case 4:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
          });
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
}
exports.initSmartContracts = initSmartContracts;